<template>

  <v-sheet
    color="transparent"
    :class="$vuetify.breakpoint.mdAndUp && 'ma-5'"
  >
    <v-layout>
      <v-icon
        size="48"
        color="grey lighten-2"
        class="align-self-start mr-2"
      >
        format_quote
      </v-icon>

      <div class="pt-3 font-italic">
        <p class="subheading font-weight-light white--text">{{ testimonial.text }}</p>

        <v-layout
          justify-end
          align-center
        >
          <span class="white--text">{{testimonial.person}} &nbsp;|&nbsp;</span>
          
          <router-link class="white--text" v-if="testimonial.slug" :to="{name: 'showCompany', params: {id: testimonial.slug}}">
            {{testimonial.firma}}
          </router-link>

          <span class="white--text" v-else>
            {{testimonial.firma}}
          </span>
        </v-layout>
      </div>
    </v-layout>
  </v-sheet>
</template>

<script>
export default {
  props: ['testimonial'],
  components: {
    // ListingSave
  },

  data () {
    return {}
  },
  computed: {},
  mounted: function () {},
  methods: {}
}
</script>

<style>
</style>